module.exports = __webpack_public_path__ + "img/ayudantes.b720429e.png";